import { useMemo, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Onboarding } from "@boundary/widgets/onboarding";
import { LOGIN_FLOW, LoginFlowData, LoginFlowSteps } from "@boundary/pages/3.login/loginFlow";
import { prefetchAndNavigate } from "@boundary/utils/prefetchRoute";

const VALID_STEPS: LoginFlowSteps[] = ["legal", "phone", "otp", "name"];

const DEBUG_MOCK_DATA: Record<LoginFlowSteps, Partial<LoginFlowData>> = {
  legal: {},
  phone: {},
  otp: { phone: "+7 (999) 123-45-67" },
  name: { phone: "+7 (999) 123-45-67", otp: "123456" }
};

export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const stepParam = searchParams.get("step") as LoginFlowSteps | null;
  const isDebugMode = stepParam && VALID_STEPS.includes(stepParam);
  // startingSlide должен обновляться при изменении stepParam
  const startingSlide = useMemo(() => {
    return isDebugMode ? stepParam : "legal";
  }, [isDebugMode, stepParam]);

  const initialData = useMemo(() => {
    if (isDebugMode && stepParam) {
      return DEBUG_MOCK_DATA[stepParam];
    }
    return undefined;
  }, [isDebugMode, stepParam]);

  const handleComplete = useCallback(
    async (data: LoginFlowData) => {
      prefetchAndNavigate(navigate, "/onboarding", { replace: true });
    },
    [navigate]
  );

  return (
    <Onboarding
      onComplete={handleComplete}
      startingSlide={startingSlide}
      initialData={initialData}
      slides={LOGIN_FLOW}
    />
  );
}
